import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { luxService } from "@/modern/services/luxService";

/**
 * Guard da rota /apps/lux.
 *
 * Trava no nível da rota: enquanto a Lux estiver desativada no backoffice (kill
 * switch), o aluno não pode nem acessar a página pela URL direta — é
 * redirecionado para o dashboard. Isso impede que ela seja vista antes do
 * lançamento oficial, mesmo que alguém descubra o path no bundle.
 *
 * Qualquer motivo de indisponibilidade cai no mesmo redirect: desativada,
 * usuário sem acesso (402) ou falha ao consultar o config. O padrão seguro é
 * não mostrar a Lux.
 */
export async function luxGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> {
  try {
    const config = await luxService.fetchConfig();

    if (config?.enabled === true) {
      return next();
    }
  } catch {
    // 402 (sem acesso), API fora, etc. — trata como indisponível.
  }

  return next({ name: "dashboard", replace: true });
}
